var lipVideos 	= [];
var videoTimes 	= [];
var mainMoviePC, mainMovieSP;
videojs.hook('setup', function(player){
	var id = player.id_;
	if(id === "video-3" || id === "video-4"){
		player.muted(true);
		player.pause();
		if(id === "video-3"){
			player.on('timeupdate', function(e) {
				if(!$("#blk-lip03 .movie").hasClass("playing")){
					$("#blk-lip03 .movie").addClass("playing");
				}
				var ratio = player.currentTime() / player.duration(), label, cls;
				var progress = ratio*100;
				var movieID = $("#blk-lip03 .movie");
				$("#blk-lip03 .ui-video .timeline p").css("width", progress + "%");
				if(ratio >= .97){
					label = '100percent_play';
					cls = "time100";
					if($("#blk-lip03 .movie").hasClass("playing")){
						$("#blk-lip03 .movie").removeClass("playing");
					}
				}else if(ratio >= 0.75 && ratio < 1){
					label = '75percent_play';
					cls = "time75";
				}else if(ratio >= 0.5 && ratio < 0.75){
					label = '50percent_play';
					cls = "time50";
				}else if(ratio >= 0.25 && ratio < 0.5){
					label = '25percent_play';
					cls = "time25"
				}else{
					label = "start_play";
					cls = "time0";
				}
				if(!movieID.hasClass(cls)){
					movieID.removeClass(function(index, className) {
						return (className.match(/\btime\S+/g) || []).join(' ');
					});
					movieID.addClass(cls);
					let category 	= "main_movie";
					let action 		= "play";
					//common.sendClickGa(label, category, action);
					//GAにプッシュする
				}
			});
		}else if(id === "video-4"){
			//console.log(id, player)
			lipVideos[3] = player;
			var movieID = $("#blk-lip04 .movie");
			let label04, cls;
			//console.log(player,"ontimeupdate")
			player.on('timeupdate', function(e) {
				if(!$("#video-4").hasClass("vjs-playing")){ return false}

				var ratio = player.currentTime() / player.duration();
				//console.log(ratio)
				//console.log(ratio, player.currentTime, player.duration)
				if(ratio >= .98){
					label04 	= 'end';
					cls 		= "time100";
					sendMovie4Ga();
					//common.sendClickGa(label02, category, action);
				}else if(ratio >= 0 && ratio < 0.1){
					label04 	= 'start';
					cls 		= "time0";
					sendMovie4Ga();
				}
				function sendMovie4Ga(){
					if(!movieID.hasClass(cls)){
						movieID.removeClass(function(index, className) {
							return (className.match(/\btime\S+/g) || []).join(' ');
						});
						movieID.addClass(cls);
						//console.log(cls)
						let category 	= "motion02";
						let action 		= "play";
						common.sendClickGa(label04, category, action);
						//GAにプッシュする
					}
				}
			});
		}
		
		if(id === "video-3"){
			lipVideos[2] = player;
			var $blockID = $("#blk-lip03");
				$(".video-js video").off().on("click", function(){
				var $thisMovie = $(this).parent();
				if($thisMovie.hasClass("active")){
					$thisMovie.removeClass("active");
				}else{
					$thisMovie.addClass("active");
				}
			});
			$("#blk-lip03 a.thumb").off().on("click", function(){
				if(!$("#blk-lip03 .movie").hasClass("playing")){
					$("#blk-lip03 .movie").addClass("playing");
				}
				lipVideos[2].play();
			});
			$blockID.find(".ui-video .btn-playback").off().on("click", function(){
				var $this = $(this);
				player.currentTime(0);
				//google analytics
				let label 		= $this.attr("data-ga");
				let category 	= $this.attr("data-category");
				let action 		= "back"
				common.sendClickGa(label, category, action);
			});
			$blockID.find(".ui-video .btn-toggleplay").off().on("click", function(){
				var $this = $(this);
				if(player.paused()){
					$this.removeClass("active");
					player.play();
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "play";
				} else {
					$this.addClass("active");
					player.pause();
					//google analytics
					var label = $this.attr("data-ga");
					var category = $this.attr("data-category");
					var action = "stop";
				}
				common.sendClickGa(label, category, action);
			});
			$blockID.find(".ui-video .btn-volume").off().on("click", function(){
				var $this = $(this);
				if(player.muted()){
					$this.addClass("active");
					player.muted(false);
				} else {
					$this.removeClass("active");
					player.muted(true);
				}
			});
		}
	}else if(id === "video-5"){
		lipVideos[4] = player;
	}
});
var vol1 = {
	players: [],
	timer: "",
	init: function(){
		let $body = $("body");
		var $blockID = $("#video-4");
		var imgArry = [];
		this.resize();
		$(".video-js").each(function(i){
			var thisID = $(this).attr("id");
			videojs(thisID);
		});

		$("#wrapper img").each(function(){
			imgArry.push($(this).attr("src"));
		});
		preloadPage.startLoad(imgArry.length,imgArry, 0).done(function(){
			vol1.startContent();
		});
		$("#block-nav").on("touchmove", function(e){
			if($html.classList.contains("show-nav")){
				e.preventDefault();
			}
		});
	},
	startContent: function(){
		let $body = $("body");
		$body.removeClass("disable");
		vol1.startVideo();
		$(".movie").addClass("active");
		setTimeout(function(){
			$("#lip #main").addClass("active");
			//動画終わり
			setTimeout(function(){
				$body.removeClass("fixed");
				$("#loading").remove();
				setTimeout(function(){
					let posY = $("#ttl-page .ttl-page-content").offset().top;
					common.scrollToPosition(posY, 600);
				},100);
			},1500);
		},600);
		$(document).on("scroll touchmove", function(){
			vol1.scrl();
		});
		vol1.nav();
	},
	nav: function(){
		let $body = $("body"),
			modalMovie = $("#video-5")[0];

		modalMovie.addEventListener('ended', function() {
			modalMovie.currentTime = 0;
		}, false);
		$("a.btn-modal").off().on("click", function(){
			let $this = $(this);
			if(!$html.classList.contains("show-movie")){
				common.sendClickGa("modal_open", "main_movie", "click");

				$html.classList.add("movie");
				setTimeout(function(){
					$html.classList.add("show-movie");
					setTimeout(function(){
						lipVideos[4].play();
						$("#video-5_html5_api").off().on("ended", function(){
							$("#video-5_html5_api")[0].currentTime = 0;
						});
						if($("#video-3").hasClass("vjs-playing")){
							lipVideos[2].pause();
						}
					},600);
				},50);
			}
		});
		$("#bg-movie").off().on("click", function(){
			closeMovie();
		});
		$("a.btn-close-movie").off().on("click", function(){
			closeMovie();
		});
		function closeMovie(){
			if($html.classList.contains("show-movie")){
				$html.classList.remove("show-movie");
				setTimeout(function(){
					$html.classList.remove("movie");
					lipVideos[4].pause();
				},600);
			}
		}
		$("#blk-lip01").off().on("click", function(){
			//mainMovieSP.play();
			//console.log(mainMovieSP.paused)
			if(mainMovieSP.paused){
				//console.log("here")
				mainMovieSP.play();
			}
		});
	},
	resize: function(){
		let winW = $(window).width(),
			winH = $(window).height();
		let rx = 1114,
			ry = 750,
			minw = 960,
			minh = 646;

		var sizes_pc	= fs(rx, ry, minw, minh, winW, winH);
		
		//var sizes_sp 	= fs(rx, ry, minw, minh, )
		sizes_pc[0] = sizes_pc[0];
		sizes_pc[1] = sizes_pc[1];
		//console.log(sizes_pc[0], sizes_pc[1]);
		
		$("#main_pc").css({
			"width" : sizes_pc[0] + "px",
			"height": sizes_pc[1] + "px"
		});
		if(isIPad){
			var sizes_sp 	= fs(768, 1141, 768, 1141, winW, window.innerHeight);
		}else if(isSP || isSmallScreen){
			var sizes_sp 	= fs(750, 1114, 320, 475, winW, window.innerHeight);
		}
		if(isIPad || isSP || isSmallScreen){
			if(sizes_sp[0] < winW){
				sizes_sp[0] = winW;
				sizes_sp[1] = sizes_sp[0]*1114/750;
				sizes_sp[2] = 0;
				sizes_sp[3] = 0;
			}
			console.log(sizes_sp[0],winW)
			$("#main_sp").css({
				"width" : sizes_sp[0] + "px",
				"height": sizes_sp[1] + "px",
				"left": sizes_sp[2] + "px",
				"top": sizes_sp[3] + "px"
			});
		}
		
		mainMoviePC = $("#main_pc")[0];
		mainMovieSP = $("#main_sp")[0];

		if(isSmallScreen){
			mainMoviePC.pause();
			mainMovieSP.play();
		}else{
			mainMoviePC.play();
			mainMovieSP.pause();
		}
	},
	startVideo: function(){
		mainMoviePC = $("#main_pc")[0];
		mainMovieSP = $("#main_sp")[0];
		let category 	= "motion01";
		let action 		= "play";
		let label02 	= "start";

		if(isSmallScreen){
			mainMoviePC.pause();
			mainMovieSP.play();
			common.sendClickGa(label02, category, action);
		}else{
			mainMoviePC.play();
			mainMovieSP.pause();
			common.sendClickGa(label02, category, action);
		}
		$("#main_sp").on('timeupdate', function() {
			let endTime = this.duration;
			let c = this.currentTime;
			if(c >= endTime-.3){
				common.sendClickGa("end", category, action);
				common.sendClickGa(label02, category, action);
			}
		});
		$("#main_pc").on('timeupdate', function(e) {
			let endTime = this.duration;
			let c = this.currentTime;
			if(c >= endTime-.3){
				common.sendClickGa("end", category, action);
				common.sendClickGa(label02, category, action);
			}
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			alen = animates.length,
			winH = $(window).height(),
			$body = $("body");
		common.checkScrolledPos(topD);
		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}else{
				if(btmD >= animates[a].show){
					activeAnimation(a)
				}
			}
		}
		if(btmD > winH){
			if(!$body.hasClass("hide_logo")){
				$body.addClass("hide_logo");
			}
		}else{
			if($body.hasClass("hide_logo")){
				$body.removeClass("hide_logo");
			}
		}
		//Parallax
		if(topD > $("#blk-lip01 .txt").offset().top){
			if(!$body.hasClass("show_bg")){
				$body.addClass("show_bg");
				mainMoviePC.pause();
				mainMovieSP.pause();
			}
		}else{
			if($body.hasClass("show_bg")){
				$body.removeClass("show_bg");
				if(isSmallScreen){
					mainMovieSP.play();
				}else{
					mainMoviePC.play();
				}
			}
		}
		if(topD > $("#blk-lip04").offset().top){
			if(!$body.hasClass("show_bg02")){
				$body.addClass("show_bg02");
			}
		}else{
			if($body.hasClass("show_bg02")){
				$body.removeClass("show_bg02");
			}
		}
		if(btmD >= $(document).height()-50){
			if(!$body.hasClass("btm")){
				$body.addClass("btm");
			}
		}else{
			if($body.hasClass("btm")){
				$body.removeClass("btm");
			}
		}
		//lipVideos[3]
		var video4Top = $("#video-4").offset().top;
		var video4Btm = video4Top + $("#video-4").outerHeight();
		if(btmD >= video4Top && topD < video4Btm){
			if(!$("#video-4").hasClass("vjs-playing")){
				lipVideos[3].play();
				//初回の再生時だけGAをtimeupdateに頼らず送るためのplayed
				if(!$("#video-4").hasClass("played")){
					$("#video-4").addClass("played");
					let category 	= "motion02";
					let action 		= "play";
					let label 		= "start"
					common.sendClickGa(label, category, action);
				}
			}
		}else if(btmD < video4Top){
			if($("#video-4").hasClass("vjs-playing")){
				lipVideos[3].pause();
			}
		}
		if(topD >= video4Btm){
			if($("#video-4").hasClass("vjs-playing")){
				lipVideos[3].pause();
			}
		}
		var movie3top = $("#blk-lip03 .movie").offset().top,
			movie3btm = movie3top + $("#blk-lip03 .movie").outerHeight() + winH;
		if(btmD < movie3top){
			if($("#video-3").hasClass("vjs-playing")){
				lipVideos[2].pause();
			}
		}else if(btmD > movie3btm){
			if($("#video-3").hasClass("vjs-playing")){
				lipVideos[2].pause();
			}
		}else{
			if($("#video-3").hasClass("vjs-paused") && !$("#video-3").hasClass("played")){
				lipVideos[2].play();
				var category 	= "main_movie",
					label 	 	= "start_play",
					action 		= "play";
				common.sendClickGa(label, category, action);
				$("#video-3").addClass("played");
			}
		}
		function activeAnimation(a){
			var $block = $(".a").eq(a);
			if(!$block.hasClass("animate")){
				$block.addClass("animate");
				if($block.attr("data-movieid") === "3"){
					setTimeout(function(){
						if($("#blk-lip03 .movie").hasClass("active")){
							$("#blk-lip03 .movie").removeClass("active");
						}
					},2000);
				}
				if($block.attr("data-movieid") === "4"){
					setTimeout(function(){
						if($("#blk-lip04 .movie").hasClass("active")){
							$("#blk-lip04 .movie").removeClass("active");
						}
					},2000);
				}
				setTimeout(function(){
					$block.addClass("animated");
				},1000);
			}
		}
		//ga
		var galen = gablocks.length;
		for(var g = 0; g < galen; g++){
			if(btmD >= gablocks[g].top){
				activeGa(g)
			}
		}
		function activeGa(g){
			var $blk = $(".gablock").eq(g);
			if(!$blk.hasClass("active")){
				$blk.addClass("active");
				var label = $blk.attr("data-ga");
				common.sendScrollPageGa(label);
			}
		}
	}
}